import { faNoteSticky } from '@fortawesome/pro-solid-svg-icons'
import type { NotesEvent } from '~/domains/actions/types'
import { BaseHistoryCard } from './BaseHistoryCard'
import { HistoryItemContent } from './HistoryItemContent'

export const NotesHistoryCard = ({ event }: { event: NotesEvent }) => {
  return (
    <BaseHistoryCard
      event={event}
      title={event.actionType ?? 'Note'}
      icon={faNoteSticky}
    >
      {event.notes && <HistoryItemContent>{event.notes}</HistoryItemContent>}
    </BaseHistoryCard>
  )
}
